<template>
  <div class="card mt-3">
    <h5 class="card-header d-flex justify-content-between align-items-center">
      <span><i class="bi bi-bug"></i> Bug Instructions</span>
      <button
        class="btn btn-sm btn-outline-primary"
        :disabled="loading"
        @click="generate"
      >
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
        Generate
      </button>
    </h5>
    <div class="card-body p-0">
      <div v-if="error" class="alert alert-danger m-3 mb-0">{{ error }}</div>
      <div v-if="loading && !items.length" class="p-3 text-center text-muted">
        <span class="spinner-border spinner-border-sm"></span> Loading...
      </div>
      <ul v-else-if="items.length" class="list-group list-group-flush">
        <li v-for="bi in items" :key="bi.id" class="list-group-item">
          <div class="d-flex justify-content-between align-items-start">
            <span class="badge category-badge me-2" :class="categoryClass(bi.category)">
              {{ bi.category || 'general' }}
            </span>
            <button
              class="btn btn-sm btn-outline-danger"
              :disabled="loading"
              title="Delete"
              @click="remove(bi.id)"
            >
              <i class="bi bi-trash"></i>
            </button>
          </div>
          <p class="mb-1 mt-2">{{ bi.description }}</p>
          <pre v-if="bi.sql_snippet" class="sql-snippet mb-0"><code>{{ bi.sql_snippet }}</code></pre>
        </li>
      </ul>
      <div v-else class="p-3 text-muted">No bug instructions yet.</div>
    </div>
  </div>
</template>

<script>
import BugInstructionController from '@/controllers/BugInstructionController';
import BugInstruction from '@/models/bugInstruction';

export default {
  name: 'BugInstructionList',
  props: {
    subtaskId: { type: [Number, String], required: true },
  },
  data() {
    return {
      items: [],
      loading: false,
      error: null,
    };
  },
  async created() {
    await this.refresh();
  },
  methods: {
    categoryClass(category) {
      return BugInstruction.categoryClass(category);
    },
    async refresh() {
      this.loading = true;
      this.error = null;
      try {
        this.items = await BugInstructionController.getBySubtask(this.subtaskId);
      } catch (e) {
        this.error = e.message || 'Failed to load bug instructions';
      } finally {
        this.loading = false;
      }
    },
    async generate() {
      this.loading = true;
      this.error = null;
      try {
        await BugInstructionController.synthesize(this.subtaskId, 1);
        this.$store && this.$store.dispatch('triggerAlert', {
          type: 'success',
          title: 'Bug instructions',
          message: 'Generated a new bug instruction',
        });
        await this.refresh();
      } catch (e) {
        this.error = e.message || 'Failed to generate bug instruction';
      } finally {
        this.loading = false;
      }
    },
    async remove(id) {
      if (!confirm('Delete this bug instruction?')) return;
      this.loading = true;
      this.error = null;
      try {
        await BugInstructionController.delete(id);
        await this.refresh();
      } catch (e) {
        this.error = e.message || 'Failed to delete bug instruction';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.category-badge {
  font-size: 0.7rem;
  letter-spacing: 0.5px;
}
.sql-snippet {
  background: #f8f9fa;
  border: 1px solid #e2e6ea;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 0.8rem;
  max-height: 160px;
  overflow: auto;
  white-space: pre;
}
</style>
